import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { Grid, Typography } from "@material-ui/core";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";

import FormikControl from "@Components/FormikControl/FormikControl.js";
import { Button } from "@material-ui/core";
import useStyles from "@Views/Styles/LoginStyles";
import { useAuth } from "@Views/Authentication/AuthContext";
import LoadingIcon from "@Components/LoadingIcon/LoadingIcon";
import FGVLogo from "assets/img/fgv-logo.png";
import { getRedirectUrl } from "utils";
import eightAxios from "configs/axiosConfig";
import { OTP_LOGIN_URL, URLS, LOGIN_VERIFY_URL } from "configs/constants";

const LoginOtp = (props) => {
  const classes = useStyles();
  const OTPLimitSeconds = 59;
  const [redirect, setRedirect] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [empId, setEmpId] = useState("");
  const [mobile, setMobile] = useState("");
  const [timer, setTimer] = useState(true);
  const [seconds, setSeconds] = useState(OTPLimitSeconds);
  const [forgotPassword, setForgotPassword] = useState(false);
  const [resend, setResend] = useState(false);

  let initialValues = {
    otp: "",
  };

  useEffect(() => {
    if (timer) {
      if (seconds > 0) {
        setTimeout(() => setSeconds(seconds - 1), 1000);
      } else {
        setTimer(false);
      }
    }
    if (props.location.state === undefined) {
      setErrorMsg("Go back to Login Page");
    } else {
      let moNum = props.location.state.mobile_number.toString();
      if (moNum.startsWith("60")) {
        setMobile(moNum);
      } else {
        moNum = "60" + moNum;
        setMobile(moNum);
      }
      setEmpId(props.location.state.employee_id);
      if (props.location.state.forgotPassword === true) {
        setForgotPassword(true);
      }
    }
  });

  useEffect(() => {
    setTimeout(() => setErrorMsg(""), 3000);
  }, [errorMsg]);

  const { authLoading, loggedIn, logout } = useAuth();

  const onResend = () => {
    setSeconds(OTPLimitSeconds);
    setTimer(true);
    setLoading(true);
    setResend(true);
    let data = new FormData();
    data.append("employee_id", empId);
    data.append("resend", resend);
    data.append("forgotPassword", forgotPassword);
    eightAxios
      .post(LOGIN_VERIFY_URL, data)
      .then((response) => {
        if (response.status === 200) {
          setLoading(false);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response) {
          setErrorMsg(error.response.data.message);
        } else {
          setErrorMsg(error.message);
        }
      });
  };

  const onSubmit = (values) => {
    if (values.otp.length) {
      let credentials = new FormData();
      credentials.append("otp", values.otp);
      setLoading(true);
      eightAxios
        .post(
          OTP_LOGIN_URL + props.location.state.employee_id + "/",
          credentials
        )
        .then(() => {
          setRedirect(true);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          if (error.response) {
            setErrorMsg(error.response.data.message);
            //   location.reload();
          } else {
            setErrorMsg(error.message);
            //   location.reload();
          }
        });
    }
  };

  const validationSchema = Yup.object({
    otp: Yup.string().required("OTP Required*"),
  });

  if (loggedIn) {
    let redirectUrl = getRedirectUrl();
    if (redirectUrl)
      return (
        <Redirect to={{ pathname: redirectUrl, state: { login: true } }} />
      );
    setErrorMsg("User doesn't have any module/s assigned.");
    logout();
  }

  if (loading) {
    return <LoadingIcon image text="Loading" />;
  }

  if (redirect) {
    return (
      <Redirect
        to={{
          pathname: URLS.LOGIN_FIRST_TIME_PASSWORD,
          state: { employee_id: props.location.state.employee_id },
        }}
      />
    );
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    >
      {!authLoading ? (
        (formik) => {
          return (
            <Form style={{ width: "100%" }}>
              <Grid
                className={classes.root}
                container
                spacing={2}
                direction="column"
                alignItems="center"
                justify="center"
              >
                <Grid item xs={10} sm={6} lg={3}>
                  <img src={FGVLogo} alt="FGV" width={200} />
                </Grid>
                <Grid item xs={10} sm={6} lg={3}>
                  <Typography variant="h4">LOGIN</Typography>
                </Grid>

                <Grid className={classes.grid} item xs={10} sm={6} lg={3}>
                  <Grid
                    item
                    style={{
                      fontWeight: "bold",
                      marginBottom: 18,
                    }}
                    container
                    justify="center"
                  >
                    <span>
                      OTP is sent by SMS to your Mobile Number: {mobile}
                    </span>
                  </Grid>
                  <FormikControl
                    control="restricted"
                    regex={/[^a-z ]/i}
                    variant="outlined"
                    name="otp"
                    fullWidth
                    size="small"
                    label="Enter OTP"
                  />
                  {timer ? (
                    <Grid
                      item
                      style={{
                        fontWeight: "bold",
                        marginBottom: 18,
                      }}
                      container
                      justify="center"
                    >
                      <span>00:{seconds}</span>
                    </Grid>
                  ) : (
                    <Grid
                      item
                      container
                      justify="center"
                      style={{ marginTop: "10px" }}
                    >
                      <Button onClick={onResend} className={classes.resendOtp}>
                        Resend Code?
                      </Button>
                    </Grid>
                  )}
                  <Grid item>
                    <Typography
                      align="center"
                      variant="subtitle1"
                      color="error"
                    >
                      {errorMsg ? errorMsg : ""}
                    </Typography>
                  </Grid>

                  <Button
                    type="submit"
                    disabled={!formik.isValid || authLoading}
                    variant="contained"
                    color="primary"
                    fullWidth
                  >
                    login
                  </Button>
                </Grid>
              </Grid>
            </Form>
          );
        }
      ) : (
        <LoadingIcon image text="Logging in" />
      )}
    </Formik>
  );
};

LoginOtp.propTypes = {
  location: PropTypes.object,
};
export default LoginOtp;
